import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onUnmounted, toRefs, watch } from "vue";
import { useStore } from "@/store";


const __default__ = {
  name: "KillSwitch",
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const { runnerOutputs, registerOutput, UnregisterOutput, kill } = store;

const { isRunning, currentRunner } = toRefs(store);
watch(currentRunner, () => {
  convergeCount = 0;
  prevOutput = 0;
});

registerOutput("protein-KillSwitch");
onUnmounted(() => {
  UnregisterOutput("protein-KillSwitch");
});

let requestAnimationFrameId: number | null = null;
let convergeCount = 0;
let prevOutput = 0;
function tick() {
  requestAnimationFrameId = null;
  if (!isRunning.value) return;
  const p = 1 - Math.exp(-runnerOutputs["protein-KillSwitch"] * 0.007);
  if (p >= 0.001) {
    const rand = Math.random();
    if (rand <= p || convergeCount === 50) {
      kill();
    }
    if (Math.abs(runnerOutputs["protein-KillSwitch"] - prevOutput) <= 0.0001) {
      convergeCount++;
    }
  }
  prevOutput = runnerOutputs["protein-KillSwitch"];
  requestAnimationFrameId = requestAnimationFrame(tick);
}

watch(isRunning, () => {
  if (isRunning.value && requestAnimationFrameId === null) {
    tick();
  }
});
if (isRunning.value && requestAnimationFrameId === null) {
  tick();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})